import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
@Component({
  selector: 'app-accepted-file-types-popover',
  templateUrl: './accepted-file-types-popover.component.html',
  styleUrls: [
    './accepted-file-types-popover.component.scss',
    '../../../styles/shared-mpp-styles.scss',
  ],
})
export class AcceptedFileTypesPopoverComponent {
  @Input() fileTypesList: string[];

  constructor(
    private popoverController: PopoverController,
    readonly platformService: PlatformService,
  ) {}

  async dismissPopover() {
    await this.popoverController.dismiss();
  }
}
